import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

/**
 * `CollectionState`'s smallest sibling: just the error slot, for the paginated
 * domains where `PagedCollection` owns the list and the loading flag. Their Akita
 * entity stores held a collection nothing ever read — see STEP-4D-PLAN.md.
 *
 * Compose it in a domain service rather than subclassing.
 */
export class ErrorState {
  private readonly state$ = new BehaviorSubject<string | undefined>(undefined);

  public readonly error$: Observable<string | undefined> = this.state$.pipe(distinctUntilChanged());

  public get error(): string | undefined {
    return this.state$.value;
  }

  public setError(error: string | undefined): void {
    this.state$.next(error);
  }
}
